import { render, staticRenderFns } from "./ecommendation.vue?vue&type=template&id=7ea6a628&scoped=true&"
import script from "./ecommendation.vue?vue&type=script&lang=js&"
export * from "./ecommendation.vue?vue&type=script&lang=js&"
import style0 from "./ecommendation.vue?vue&type=style&index=0&id=7ea6a628&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ea6a628",
  null
  
)

export default component.exports